export default {
  loading: "Loading...",
  open: "Open",
  close: "Close",
  stake: "cược",
  crdr: "W/L",
  item: "Item",
  valid: "Valid",
  home_preferences: "Home Preferences",
  quick_links: "Quick Links",
  language: "Language",
  home_page: "Home",
  favorites: "Ưa thích",
  note: "Ghi chú",
  my_bets: "Cược của tôi",
  my_account: "Tài khoản của tôi",
  contact_us: "Liên hệ chúng tôi",
  report: "Báo biểu",
  help_support: "Hỗ trợ và giúp đỡ",
  currency: "Tiền Tệ",
  others: "Khác",
  welcome: "Chào mừng",
  account_id: "Tài khoản nhận dạng",
  password: "Mật khẩu",
  account: "Tài khoản",
  all_sports: "Mọi môn thể thao",
  my_sports: "Thể Thao",
  action: "Thao tác",
  accept_better_odds: "Tự nhận tỷ lệ cược tốt",
  accept_any_odds: "Chấp nhận bất cứ tỷ giá nào",
  auto_refresh_odds: "Tự động làm mới tỷ giá",
  auto_refresh: "Tự làm mới",
  auto_refreshing: "Đang tự động làm mới...",
  all_markets: "Toàn bộ thị trường",
  available_balance: "Available Balance",
  athletics: "THẾ VẬN HỘI",
  american_football: "BÓNG ĐÁ MỸ",
  aussie_rules_football: "ÚC QUY BÓNG ĐÁ",
  gmail: "Gmail",
  contact_number: "Số liên lạc",

  away: "Khách",

  all: "Toàn bộ",
  accepted: "Đã chấp nhận",
  add: "Thêm vào",
  add_homescreen: "Thêm vào màn hình chính",
  abandoned: "Bị bỏ rơi",

  bet_slip: "Bảng cược mini",
  bet_credit: "Tín dụng cược",
  bet_list: "Danh sách cược",
  betting: "Đặt cược",
  balance: "Số dư",

  betting_statement: "Tình trạng đặt cược",
  betting_rules: "Quy Tắc Cá Cược",
  bet_types: "Dạng đặt cược",
  bs: "B/S",
  bet_summary: "Tổng hợp cược",
  bet_reject: "Mã cược vô hiệu",
  bets: "Các mã cược",
  basketball: "BÓNG RỔ",
  baseball: "BÓNG CHÀY",
  badminton: "CẦU LÔNG",
  bandy: "Bandy",
  boxing: "QUYỀN ANH",
  beach_soccer: "BÓNG ĐÁ BÃI BIỂN",

  casino: "Sòng bạc",
  cash_balance: "Số dư tiền mặt",
  change_account_password: "Thay đổi mật khẩu tài khoản",
  current_password: "Mật khẩu hiện tại",
  confirm_new_password: "Xác nhận mật khẩu mới",
  customize_sports_order: "Tuỳ chỉnh thứ tự thể thao",
  choice: "Lựa chọn",
  credit: "Tín dụng",
  commission: "Hoa hồng",
  customize: "Tuỳ chỉnh",
  cancel: "Hủy",
  confirmation: "Xác nhận",
  continue_bet: "Continue Bet",
  customer_service: "Customer Service Hotline",
  cricket: "BÓNG CHÀY",
  cycling: "ĐẠP XE",
  copa_america: "Copa America",
  combinations: "Kết hợp",
  create_room: "Tạo phòng",

  darts: "PHI TIÊU",
  debit: "Ghi nợ",
  display_language: "Ngôn ngữ hiển thị",
  default_event_sorting: "Mặc định sắp xếp sự kiện",
  default_stake: "Cược mặc định",
  date: "Ngày",
  draw: "Hòa",
  draw_cancel: "Hòa",
  dec: "DEC",
  double_line: "Hiện thị 2 dòng",
  disable: "Vô hiệu hoá",
  dec_odds: "Tỷ giá thập phân",
  id_odds: "Tỷ giá Indo",
  double_chance: "Nhân đôi cơ hội",
  details: "Chi tiết",

  enable: "Kích hoạt",
  event_sorting: "Sắp xếp sự kiện",
  e_sports: "Thể thao điện tử",
  esports2: "Thể thao điện tử 2",
  edit: "Thiết lập",
  early: "Sớm",
  event: "Sự kiện",
  even: "Chẵn",
  email: "Email",
  esports: "THỂ THAO ĐIỆN TỬ",
  euro: "EURO 2020",
  entry_fee: "Phí vào cửa",
  exclusive: "Độc quyền",
  event_worldcup: "Worldcup 2026",
  event_euro: "EURO 2024",
  event_copa: "COPA 2024",
  event_olympic: "Olympic 2024",
  event_club_worldcup: "CLUB WORLD CUP",
  event_women_euro: "WOMEN's EURO",
  event_nation_league: "NATION LEAGUE",
  event_fifa_club: "FIFA CLUB",

  es_101: "Bản đồ 1",
  es_102: "Bản đồ 2",
  es_103: "Bản đồ 3",
  es_104: "Bản đồ 4",
  es_105: "Bản đồ 5",
  es_106: "Bản đồ 6",
  es_107: "Bản đồ 7",
  es_108: "Bản đồ 8",
  es_109: "Bản đồ 9",
  es_110: "Bản đồ 10",
  euroDate: "12 JUNE - 12 JULY",

  fd_101: "Giải nhất",
  fd_102: "Giải nhì",
  fd_103: "Giải ba",

  first_goal: "Bàn thắng đầu",
  first_half: "Hiệp đầu",
  final: "Kết",
  full_time: "Cả trận",
  fold: "Bỏ lượt",
  first_5_inn: "5 lượt đầu tiên",
  from: "From",
  field_hockey: "KHÚC CÔN CẦU",
  futsal: "BÓNG ĐÁ TRONG NHÀ",
  fd: "4D Special",
  fishing: "Fishing",

  gaelic_football: "BÓNG ĐÁ GAELIC",
  golf: "ĐÁNH GÔN",
  games: "Trò chơi",
  given_credit: "thêm tín dụng",
  group: "Nhóm",
  goal: "Bàn thắng",
  general: "General",
  general_betting_rules: "Luật cá cược chung",
  general_rules_market: "Quy tắc chung: Thị trường (Loại đặt cược)",

  half_time: "Hiệp 1",
  hide_header: "Ẩn tiêu đề",
  hk: "Hồng Kông",
  hk_odds: "Tỷ giá Hồng Kông",
  home: "Chủ nhà",
  hdp: "HDP",
  hotline: "Hotline",
  handball: "BÓNG NÉM",
  hurling: "ĐÁNH BÓNG BẰNG GẬY",
  hour: "Giờ",
  highlight: "Điểm nổi bật",

  id: "Xác thực",
  inactive: "Không hoạt động",
  inplay: "Đang chơi",

  ice_hockey: "KHÚC CÔN CẦU BĂNG",

  joined: "Chỉ tham gia",
  join_now: "Tham gia ngay",
  jackpot: "แจ็คพอต",

  keno: "Trò chơi số",
  kickoff: "Phát bóng",
  kabbadi: "THỂ THAO ẤN ĐỘ",
  kof: "King of Figthers",
  ko: "K.O By",

  lose: "Lose",
  lose_half: "Thua nữa",
  lottery: "Xổ số",
  login: "Đăng nhập",
  logout: "Đăng xuất",
  last_login: "Lần đăng nhập cuối cùng",
  last_transaction: "Lần giao dịch cuối cùng",
  live_streaming: "Đang trực tiếp",
  live_match: "Trận đang trực tiếp",
  live: "Trực tiếp",
  virtual: "Ảo",
  live_tv: "Truyền hình trực tiếp",
  live_chat: "Live Chat",
  livecasino: "Sòng bạc trực tuyến",
  loss: "Thua",
  lost: "Mất",
  last_bet: "Cược cuối",
  last_goal: "Bàn thắng cuối",
  leave_room: "Rời Phòng",
  last_betting_time: "Thời gian đặt cược cuối cùng",
  lose_all: "Mất tất cả",

  mobile: "Điện thoại",
  message: "Tin nhắn",
  my_bet: "Cược của tôi",
  my_favorites: "Ưa thích của tôi",
  market_type: "Dạng thị trường",
  match: "Trận đấu",
  message_history: "Lịch sử tin nhắn",
  my: "Mã Lai",
  market: "Thị trường",
  main_markets: "Thị trường chính",
  my_odds: "Tỷ giá Mã Lai",
  min: "Thấp nhất",
  max: "Lớn nhất",
  max_payout: "Trả thưởng tối đa",
  main: "Chính",
  corners: "Phạt góc/Thẻ",
  specials: "Đặc biệt",
  mix_parlay: "Xiên hỗn hợp",
  moneyline: "Dòng tiền",
  mma: "VÕ THUẬT HỖN HỢP (MMA)",
  motorsports: "ĐUA XE",
  muay_thai: "VÕ THUẬT THÁI",
  map1: "Map 1",
  map2: "Map 2",
  map3: "Map 3",
  map4: "Map 4",
  map5: "Map 5",
  map6: "Map 6",
  map7: "Map 7",
  map8: "Map 8",
  map9: "Map 9",
  matches: "Diêm",
  mini_arcade: "Mini Arcade",
  match_started: "-",

  no_goal: "Không có bàn thắng",
  normal_announcements: "Thông báo thường",
  nickname: "Biệt danh",
  new_password: "Mật khẩu mới",
  new: "Mới",
  "no/": "Thứ tự.",
  normal_sorting: "Sắp xếp bình thường",
  netball: "BÓNG LƯỚI",
  newsinfo: "Tin tức & Thông tin",
  next: "Tiếp theo",

  olympic: "Olympic",
  other_markets: "Các thị trường khác",
  outstanding: "Mã cược đang chạy",
  odds_type: "Dạng tỷ giá",
  odds: "Tỷ giá",
  opening_balance: "Số Dư Chờ Xử Lý",
  outright: "Vô địch",
  oe: "Lẻ/Chẵn",
  on: "Mở",
  off: "Đóng",
  outstanding_bet: "Mã cược đang chạy",
  over: "Tài",
  odd: "Tỷ giá",
  official_link: "Liên kết chính thức",
  owner: "Chủ phòng",
  ou:"O/U",

  password_expiry: "Mật khẩu hết hạn",
  parlay: "Xiên",
  parlay_early: "Xiên sớm",
  mmo_parlay: "Xiên Myanmar",
  mmo_odds: "Tỷ lệ cược Myanmar",
  page_display: "Hiển thị trang",
  page_type: "Dạng trang",
  page_size: "Kích cỡ trang",
  personal_message: "Tin nhăn cá nhân",
  process_bet: "Đặt cược",
  payout: "Trả thưởng",
  pending: "Đang chờ xử lý",
  personal: "Cá nhân",
  play_now: "Chơi ngay",
  parlay_generator: "Parlay Generator",
  private: "Riêng tư",
  pool: "Trả thưởng $",
  players: "Người chơi",
  points: "điểm",
  prize: "Giải thưởng",
  play_to_earn: "Chơi để kiếm",
  
  quick_bet: "Cược nhanh",
  qq: "QQ",

  room: "Phòng",
  result: "Kết quả",
  restore: "Phục hồi",
  remark: "Ghi chú",
  ref_no: "Thứ tự mã cược.",
  remove_from_parlay: "Gỡ xiên",
  running: "Đang chạy",
  reject: "Huỷ bỏ",
  rugby: "BÓNG BẦU DỤC",
  roundof16: "Vòng 16",
  quater_finals: "Vòng tứ kết",
  semi_finals: "Bán kết",
  room_id: "ID phòng",
  refund: "hoàn tiền",

  skype: "Skype",
  sports: "Thể thao",
  show_balance: "Hiển thị số dư",
  statement: "Sao kê",
  settings: "Cài đặt",
  search_team: "Tìm kiếm đội",
  show_header: "Hiển thị tiêu đề",
  submit: "Chấp nhận",
  set_nickname: "Đặt biệt danh",
  single: "Đơn",
  save: "Lưu",
  show_score_map: "Hiển thị đồ thị điểm",
  status: "Tình trạng",
  sort: "Sắp xếp",
  sportsbook: "Thể thao",
  sum: "Tổng",
  special_announcements: "Tin nhắn đặc biệt",
  subtotal: "Tổng",
  single_line: "Dòng đơn",
  sort_by_time: "Sắp xếp theo thời gian",
  slots: "máy xèng",
  select_leagues: "lựa chọn giải đấu",
  special: "Special",
  scroll_bottom: "Tap to scroll to betting area",
  swipe_to_search: "Swipe To Search",
  soccer: "BÓNG ĐÁ",
  squash: "BÍ ĐAO",
  sepak_takraw: "CẦU MÂY",
  snooker: "Bi-A",
  suite_sa: "SA Gaming",
  suite_gp: "Game Play",
  suite_evo: "Evolution",
  suite_ct855: "CT855",
  suite_bg: "Macau Suite",
  suite_pg: "Pretty Gaming",
  suite_yb: "Yeebet",
  "suite_pp-c": "Pragmatic",
  suite_ai: "AI Casino",
  suite_sexy: "Sexy Casino",
  suite_onlive: "Onlive Casino",
  suite_mt: "MT Casino",
  suite_foxy: "Foxy Casino",
  sfv_101: "Vòng 1",
  sfv_102: "Vòng 2",
  sfv_103: "Vòng 3",
  sfv_104: "Vòng 4",
  sfv_105: "Vòng 5",
  settlement: "Giải quyết",
  settled_amount: "Số tiền giải quyết",
  search: "Tìm kiếm",
  settled: "Đã Thanh Toán",
  sysparlay: "Cược xiên hệ thống",
  stake_per_bet: "Stake Per Bet",
  score: "Ghi bàn",
  winner: "Người chiến thắng",
  slot_live22: "Live22",
  slot_pgs: "PGSoft",
  slot_ppg: "Pramagtic Play",
  slot_jkr: "Joker",
  slot_spp: "Simple Play",
  slot_jili: "Jili",
  slot_uusl: "UUSlot",
  slot_next: "Nextspin",
  slot_dbhash: "DB Hash",
  slot_wow: "WOW Gaming",
  slot_wf: "WF Gaming",
  slot_epw: "Epicwin",
  slot_epwmg: "Epicwin Mini",
  selected: "Đã chọn",
  select_matches: "Chọn trận đấu",

  turnover: "Doanh số",
  today: "Hôm nay",
  time: "Thời gian",
  team: "Đội",
  to: "Đến",
  trans_time: "đổi thời gian",
  total: "tổng",
  total_goal: "tổng bàn thắng",
  treble: "Cú ăn ba",
  total_bets: "Total Bets",
  tnc: "Điều khoản và điều kiện chung",
  tennis: "QUẦN VỢT",
  table_tennis: "BÓNG BÀN",
  telegram: "Telegram",
  total_stake: "Tổng Tiền Cược",
  tournament: "Giải đấu",
  tomorrow: "Ngày mai",
  total_points: "Tổng điểm",
  tournament_refund: "Hoàn tiền giải đấu",

  under: "Xỉu",
  void: "Vô hiệu",
  volleyball: "BÓNG CHUYỀN",
  void_list: "Danh sách trống",
  view_odds: "Xem tỷ lệ cược",
  video: "Video",

  won_all: "Thắng tất cả",
  won_half: "Thắng một nửa",
  win_half: "Đã thắng 1 nữa",
  win: "Thắng",
  won: "Đã thắng",
  waiting: "Đang chờ đợi",
  wechat: "Wechat",
  whatsapp: "Whatsapp",
  winter_sports: "THỂ THAO MÙA ĐÔNG",
  water_polo: "THỦY CẦU",
  winlose: "Thắng / Thua",
  winner_rank: "Xếp hạng",

  yes: "Có",
  no: "không",

  yesterday: "Hôm qua",
  monday: "Thứ 2",
  tuesday: "Thứ 3",
  wednesday: "Thứ 4",
  thursday: "Thứ 5",
  friday: "Thứ 6",
  saturday: "Thứ 7",
  sunday: "Chủ nhật",

  all_league: "Toàn bộ",
  match_completed: "Đã hoàn tất",
  match_pending: "Kết quả chờ đợi",
  match_cancelled: "Hoàn trả",
  match_cancelled_1h: "Hoàn trả hiệp 1",
  match_cancelled_2h: "Hoàn trả hiệp 2",
  match_suspended: "Từ bỏ",
  match_suspended_1h: "Từ bỏ hiệp 1",
  match_suspended_2h: "Từ bỏ hiệp 2",

  check_all: "Kiểm tra toàn bộ",
  selected_only: "Chọn khu vực chỉ định",
  filtered: "Chọn lọc",
  turn_on: "Mở",
  turn_off: "Đóng",

  more_bet_types: "Nhiều loại cược hơn",
  switch_to_Desktop: "Chuyển sang máy tính để bàn",

  events: "Events",
  brackets: "Brackets",
  standing: "Standing",

  big_small: "Big/Small",
  odd_even: "Odd/Even",

  first_digit: "1st Digit",
  second_digit: "2nd Digit",
  third_digit: "3rd Digit",
  forth_digit: "4th Digit",
  total_4d: "Total 4D",
  total_3d: "Total 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",

  news: "Tin tức",
  more: "Thêm",
  settled_remark: "Lưu ý: Cược từ thị trường hôm nay được hiển thị, vé của trận đấu đã thanh toán sẽ được chuyển sang bảng sao kê.",
  w4d: "4D",
  deselect_all: "Bỏ chọn tất cả",
  select_all: "Chọn tất cả",
  done: "Làm xong",
  tutorial_tooltips: "Cách cài đặt ứng dụng này trên màn hình chính",
  tutorial: "Hướng dẫn",
  dismiss: "Hủy bỏ",

  seven_days: "7 Ngày Trước",
  fourteen_days: "14 Ngày Trước",

  hide: "Trốn",
  more_details: "Thêm chi tiết",
  goto_statement: "Đi tới Bản sao kê",
  transfer: "Chuyển tiền",
  no_record: "Không tìm thấy bản ghi",
  no_bet: "Không đặt cược",

  random_pick: "Phát ra",
  add_pick: "Thêm vào phiếu cược",

  worldcup: "WORLD CUP 2022",
  time_remaining: "Thời gian còn lại",

  slot_championstar: "Champion Star",
  slot_fifafiesta: "Fifa Fiesta",
  slot_penaltymania: "Penalty Mania",
  minigame_dragon: "Dragon's Treasure",
  minigame_illuvium: "Illuvium Master",
  minigame_mobo: "Mobox Olympia",

  egames: "V-Games",
  feedback: "Phản hồi người dùng",
  ranking: "Xếp hạng",
  total_winning: "Tổng số chiến thắng",
  first_prize: "Giải Nhất",
  second_prize: "Giải Nhì",
  third_prize: "Giải Ba",
  place: "Xếp hạng",
  current_point: "Điểm hiện tại",
  free_room: "Phòng Miễn phí",
  last_join_time: "Thời gian tham gia lần cuối",
  archery: "Bắn cung",
  winter_olympic: "Thế vận hội Mùa đông",
  no1: "Người Chiến Thắng Hạng Nhất",
  adjustment: "điều chỉnh",
  poker: "Xì tố",
  poker_db: "DB Poker",
  yellow: "Màu vàng",
  blue: "Màu xanh",
  first_ball: "Quả bóng đầu tiên",
  best_5_balls: "5 quả bóng tốt nhất",
  binary_allin: "Binary",
  round1: "Vòng 1",
  round2: "Vòng 2",
  round3: "Vòng 3",
  
  round1_1stBoom: "BOOM Đầu Tiên Vòng 1",
  round2_1stBoom: "BOOM Đầu Tiên Vòng 2",
  round3_1stBoom: "BOOM Đầu Tiên Vòng 3",

  modern_view: "Xem hiện đại",
  switching_to_modern_view: "Chuyển sang xem hiện đại...",
  cashout: "Rút tiền",
  available: "Có sẵn",
  
  time_machine_tm: "(Máy thời gian)",
  beta_tag: "Beta"
};
